import { render, staticRenderFns } from "./TwoFactorSetupModal.vue?vue&type=template&id=5fa27766&"
import script from "./TwoFactorSetupModal.vue?vue&type=script&lang=js&"
export * from "./TwoFactorSetupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports